export class PagingDataSourceImpl {
    api;
    operation;
    pageSize;
    constructor(api, operation) {
        this.api = api;
        this.operation = operation;
        this.pageSize = 20;
    }
    load(pageNumber = 1) {
        const parameters = {
            top: this.pageSize,
            skip: (pageNumber - 1) * this.pageSize
        };
        return this.api.request(this.operation, { parameters }).then(resp => ({
            pageStart: resp.data.page_start,
            pageSize: resp.data.page_size,
            totalCount: resp.data.total_count,
            count: resp.data.count,
            data: resp.data.data
        }));
    }
}
//# sourceMappingURL=pagingDataSource.js.map